"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionEditorRepetition = void 0;
const core_1 = require("@material-ui/core");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const react_markdown_1 = require("@opsbase/react-markdown");
const react_simple_reducer_1 = require("@opsbase/react-simple-reducer");
const useSysLang_1 = __importDefault(require("@opsbase/web-ctrl-syslang/SysLangController/useSysLang"));
const web_editablelist_1 = __importDefault(require("@opsbase/web-editablelist"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur"));
const Radio_1 = __importDefault(require("@opsbase/web-ui/Radio"));
const RadioGroup_1 = __importDefault(require("@opsbase/web-ui/RadioGroup"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
// eslint-disable-next-line no-shadow
var Options;
(function (Options) {
    Options["NTIMES"] = "nTimes";
    Options["UNLIMITED"] = "unLimitedTimes";
    Options["LIST"] = "list";
})(Options || (Options = {}));
exports.QuestionEditorRepetition = react_1.default.memo((props) => {
    const { config, onChange, disabled } = props;
    const { isAlt, language } = (0, useSysLang_1.default)();
    const [state, dispatch] = (0, react_1.useReducer)(react_simple_reducer_1.reducer, config);
    const repetitionType = state.unLimitedTimes.enabled
        ? Options.UNLIMITED
        : state.list.enabled
            ? Options.LIST
            : Options.NTIMES;
    const listItems = state === null || state === void 0 ? void 0 : state.list.options.map((o, idx) => {
        var _a;
        return ({
            id: idx + language,
            idx,
            title: isAlt ? ((_a = o.labelAlt) === null || _a === void 0 ? void 0 : _a[language]) || o.label : o.label,
        });
    });
    (0, react_1.useEffect)(() => {
        if (state !== config)
            onChange(state);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]);
    const handleChangeListItems = (0, react_1.useCallback)(items => {
        let value = items.map(({ title, idx }) => {
            const option = (state === null || state === void 0 ? void 0 : state.list.options[idx]) || {};
            if (isAlt) {
                return {
                    labelAlt: Object.assign(Object.assign({}, option.labelAlt), { [language]: title }),
                    label: option.label || title,
                };
            }
            else {
                return Object.assign(Object.assign({}, option), { label: title });
            }
        });
        dispatch({ field: 'list.options', value });
    }, [isAlt, language, state === null || state === void 0 ? void 0 : state.list.options]);
    const handleChangeSelection = (0, react_1.useCallback)(rt => {
        dispatch({ field: Options.NTIMES, value: { enabled: rt === Options.NTIMES } });
        dispatch({
            field: Options.UNLIMITED,
            value: { enabled: rt === Options.UNLIMITED },
        });
        dispatch({ field: Options.LIST, value: { enabled: rt === Options.LIST } });
    }, []);
    const handleChangeValue = (0, react_1.useCallback)((value) => dispatch({ field: 'nTimes', value: { value: parseInt(value) } }), []);
    return (react_1.default.createElement(Vertical_1.default, null,
        react_1.default.createElement(RadioGroup_1.default, { disabled: disabled, value: repetitionType, onChange: handleChangeSelection },
            react_1.default.createElement(Vertical_1.default, { gutter: true },
                react_1.default.createElement(Horizontal_1.default, { centered: true },
                    react_1.default.createElement(Radio_1.default, { disabled: disabled, value: 'nTimes', checked: repetitionType === 'nTimes' }),
                    react_1.default.createElement(Text_1.default, null, (0, react_markdown_1.markdown)(lib_i18n_1.default.t('questiontype-repetition-ntimes')))),
                state.nTimes.enabled && (react_1.default.createElement(Pane_1.default, { padding: "0 5" },
                    react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { disabled: disabled, type: "number", InputProps: {
                            endAdornment: 'times',
                        }, value: String(state.nTimes.value), onBlur: handleChangeValue, placeholder: lib_i18n_1.default.t('repeat-times') }))),
                react_1.default.createElement(Horizontal_1.default, { centered: true },
                    react_1.default.createElement(Radio_1.default, { disabled: disabled, value: 'unLimitedTimes', checked: repetitionType === 'unLimitedTimes' }),
                    react_1.default.createElement(Text_1.default, null, (0, react_markdown_1.markdown)(lib_i18n_1.default.t('questiontype-repetition-unlimited')))),
                react_1.default.createElement(Horizontal_1.default, { centered: true },
                    react_1.default.createElement(Radio_1.default, { disabled: disabled, value: 'list', checked: repetitionType === 'list' }),
                    react_1.default.createElement(Text_1.default, null, (0, react_markdown_1.markdown)(lib_i18n_1.default.t('questiontype-repetition-list')))),
                state.list.enabled && (react_1.default.createElement(core_1.Grid, { container: true, direction: "column" },
                    react_1.default.createElement(web_editablelist_1.default, { disabled: disabled, autoSelectIdx: 0, canDelete: true, canReorder: true, canAddInline: true, canAddAtBottom: true, items: listItems, placeholder: lib_i18n_1.default.t('add-item'), onChange: handleChangeListItems })))))));
});
exports.default = exports.QuestionEditorRepetition;
